module.exports = __webpack_public_path__ + "img/1.ad604934.jpg";